import { Form, Formik } from "formik";
import { SelectForm } from "../select-form";
import { Input } from "../../input/input";
import { PhoneInput } from "../../phone-input/phone-input";
import { OptionType, Select } from "../select";
import SelectCityFlow from "../city-select/select-city-flow";
import SelectRegionFlow from "../region-select/select-region-flow";
import { useCreateCustomAddressRequest } from "@/api/useCreateCustomAddresssRequest";
import { customAddressValidation } from "@/validations/address.validation";
import { Theme } from "@/enums";
import { useTheme } from "@/context/Theme.context";

export interface TCustomAddressForm {
  cardId: string;
  pinFl: string;
  addressLabel: string;
  regionId: OptionType | null;
  cityId: OptionType | null;
  streetName: string;
  lastName: string;
  firstName: string;
  dateOfBirth: string;
  phone: string;
  middleName?: string;
  apartmentNumber?: number | string;
  houseNumber?: number | string;
}

const AddressCustomFormUz = ({ onShowList }: { onShowList: () => void }) => {
  const theme = useTheme();
  const createCustomAddress = useCreateCustomAddressRequest();
  const handleFormSubmit = (values) => {
    const customAddressData = {
      cardId: values.cardId,
      pinFl: values.pinFl,
      addressLabel: values.addressLabel,
      regionId: values.regionId.id ? parseInt(values.regionId.id) : null,
      cityId: values.cityId.id,
      streetName: values.streetName,
      lastName: values.lastName,
      firstName: values.firstName,
      dateOfBirth: values.dateOfBirth,
      phone: values.phone?.replace("+", ""),
    };
    createCustomAddress(customAddressData).then(() => onShowList());
  };
  const initialValues: TCustomAddressForm = {
    cardId: "",
    pinFl: "",
    addressLabel: "",
    regionId: null,
    cityId: null,
    streetName: "",
    lastName: "",
    firstName: "",
    dateOfBirth: "",
    phone: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={false}
      validationSchema={customAddressValidation}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={handleFormSubmit}
    >
      {({
        values: {
          cardId,
          pinFl,
          addressLabel,
          regionId,
          cityId,
          streetName,
          lastName,
          firstName,
          dateOfBirth,
          phone,
        },
        setFieldValue,
        validateField,
        errors,
        handleChange,
        handleBlur,
      }) => {
        return (
          <Form>
            <SelectForm
              additionalFormButtonText={"Add new address"}
              onShowList={onShowList}
            >
              <>
                <Input
                  label="Name"
                  name="firstName"
                  value={firstName}
                  onChange={(e) => {
                    handleChange(e);
                    (e.target as HTMLTextAreaElement).value.length > 1 &&
                      validateField("firstName");
                  }}
                  onPaste={() =>
                    setTimeout(() => validateField("firstName"), 0)
                  }
                  onBlur={handleBlur}
                  required
                  error={errors?.firstName}
                />
                <Input
                  label="Surname"
                  name="lastName"
                  value={lastName}
                  onChange={(e) => {
                    handleChange(e);
                    (e.target as HTMLTextAreaElement).value.length > 1 &&
                      validateField("lastName");
                  }}
                  onPaste={() => setTimeout(() => validateField("lastName"), 0)}
                  onBlur={handleBlur}
                  required
                  error={errors?.lastName}
                />
                <Input
                  label="Date of birth"
                  name="dateOfBirth"
                  type="date"
                  value={dateOfBirth}
                  onChange={(e) => {
                    handleChange(e);
                    (e.target as HTMLTextAreaElement).value.length > 1 &&
                      validateField("dateOfBirth");
                  }}
                  onPaste={() =>
                    setTimeout(() => validateField("dateOfBirth"), 0)
                  }
                  onBlur={handleBlur}
                  required
                  error={errors?.dateOfBirth}
                />
                <Input
                  label="Card Id"
                  name="cardId"
                  value={cardId}
                  onChange={(e) => {
                    handleChange(e);
                    (e.target as HTMLTextAreaElement).value.length > 1 &&
                      validateField("cardId");
                  }}
                  onPaste={() => setTimeout(() => validateField("cardId"), 0)}
                  onBlur={handleBlur}
                  required
                  error={errors?.cardId}
                />
                <Input
                  label="PNFl"
                  name="pinFl"
                  value={pinFl}
                  onChange={(e) => {
                    handleChange(e);
                    (e.target as HTMLTextAreaElement).value.length > 1 &&
                      validateField("pinFl");
                  }}
                  onPaste={() => setTimeout(() => validateField("pinFl"), 0)}
                  onBlur={handleBlur}
                  required
                  error={errors?.pinFl}
                  onInfoIconClick={() =>
                    window.open(
                      "https://my3.soliq.uz/individual/cabinet/find-tin/home",
                      "_blank",
                    )
                  }
                />
                <Input
                  label="Address label"
                  name="addressLabel"
                  value={addressLabel}
                  onChange={(e) => {
                    handleChange(e);
                    (e.target as HTMLTextAreaElement).value.length > 1 &&
                      validateField("addressLabel");
                  }}
                  onPaste={() =>
                    setTimeout(() => validateField("addressLabel"), 0)
                  }
                  onBlur={handleBlur}
                  required
                  error={errors?.addressLabel}
                />
                <Select
                  label="Region"
                  selectedValue={regionId}
                  name="regionId"
                  error={errors?.regionId}
                >
                  <SelectRegionFlow
                    onSelect={(selectedOption) => {
                      setFieldValue("regionId", selectedOption);
                    }}
                  />
                </Select>
                <Select
                  label={theme === Theme.UZ ? "city_district" : "city"}
                  selectedValue={cityId}
                  name="cityId"
                  error={errors?.cityId}
                >
                  <SelectCityFlow
                    onSelect={(selectedOption) => {
                      setFieldValue("cityId", selectedOption);
                    }}
                  />
                </Select>
                <Input
                  label="Street, House"
                  name="streetName"
                  value={streetName}
                  onChange={(e) => {
                    handleChange(e);
                    (e.target as HTMLTextAreaElement).value.length > 1 &&
                      validateField("streetName");
                  }}
                  onPaste={() =>
                    setTimeout(() => validateField("streetName"), 0)
                  }
                  onBlur={handleBlur}
                  required
                  error={errors?.streetName}
                />
                <PhoneInput
                  label="Enter your phone number"
                  value={phone}
                  onChange={(params) => {
                    params.phoneNumber
                      ? setFieldValue(
                          "phone",
                          `${params.code}${params.phoneNumber}`,
                        )
                      : setFieldValue("phone", "");
                    phone?.length > 1 && validateField("phone");
                  }}
                  onPaste={() =>
                    setTimeout(() => validateField("firstName"), 0)
                  }
                  error={errors?.phone}
                />
              </>
            </SelectForm>
          </Form>
        );
      }}
    </Formik>
  );
};
export { AddressCustomFormUz };
